import {CommonMessages} from '../common.messages';

export const PanelSettingsRolesMessages = {
    GetRolesFailed: {
        key: 'GetRolesFailed',
        message: 'Error while communication with the server. Cannot get available system roles.'
    },
    ConfirmDeleteRoleCaption: {
        key: 'ConfirmDeleteRoleCaption',
        message: 'Delete role'
    },
    ConfirmDeleteRoleQuestion: {
        key: 'ConfirmDeleteRoleQuestion',
        message: 'Are you sure you want to delete role <<name>>?'
    },
    DeleteRoleFailed: {
        key: 'DeleteRoleFailed',
        message: 'Error while processing server request. Unable to delete role <<name>>.'
    },
    DeleteRoleSucceed: {
        key: 'DeleteRoleSucceed',
        message: 'Role <<name>> is successfully deleted.'
    },
    ...CommonMessages
};
